exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-437e929c] .nav.nav-pills .nav-item .nav-link{border-radius:.25rem}[data-v-437e929c] .nav.nav-pills .nav-item .nav-link.active{color:#fff}[data-v-437e929c] .tabs{border:1px solid #e5e5e5;border-radius:.25rem}[data-v-437e929c] .tabs .tab-content{border:none;padding-top:0}", ""]);

// exports
